module.exports = {template: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z" fill="#F95F5F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.9 8.414L15.485 7l-3.535 3.536L8.414 7 7 8.414l3.536 3.536L7 15.485 8.414 16.9l3.536-3.536 3.535 3.535 1.415-1.414-3.536-3.535 3.535-3.536z" fill="#fff"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/error-check.svg
// module id = 218
// module chunks = 1